<template>
    <div class="long-term-test">
        <v-container fluid>
        <v-row>

            <v-col cols="12" sm="12">
                <div class="custom-question-msg">
                    <div class="line-height-20"> Long Term Test do not support answering tests by more than 25 students at a time.
Are you sure this is a Long Term Test?</div>
                </div>
            </v-col>
                    <v-col cols="12" sm="12">
                    <div class="right-align">
                        <v-btn @click="onClose({status:false ,longTerm: true})" class="right-btn cust-btn mr-4" color="primary">Yes</v-btn>
                        <v-btn @click="onClose({status:false,longTerm: false})" class="right-btn cust-btn" color="primary">No</v-btn>
                    </div>
                </v-col>
        </v-row>
    </v-container>
    </div>
</template>
<script>
export default {
  name: "LongTermTestPopup",
  props: ["onClose","data"],
  data() {
    return{
    }
  },
};
</script>